import PageNotFound from "./PageNotFound/PageNotFound";
import TauriDashboard from "./components/TauriDashboard/TauriDashboard";
import TauriSearchResult from "./components/TauriSearchResult/TauriSearchResult";
import TauriListings from "./components/TauriListings/TauriListings";

const AppRoutes = [
  {
    path: 'dashboards/:id',
    element: <TauriDashboard />
  },
  {
    path: 'searchresult',
    element: <TauriSearchResult />
  },
  {
    path: 'list/:id',
    element: <TauriListings />
  }
];

export default AppRoutes;
